// @ts-nocheck converted from existing component
// If making changes look to fix and remove this

import React from "react"
import Notification from "../Notification"
import { useContentJsx } from "@/utils/hooks/useContent"
import { useVariancesQuery, selectHasGss } from "@/store/apis/linkApi"
import { format } from "date-fns"
import { currentDate } from "@/utils/helpers/dateHelpers"
import { useSelector } from "react-redux"
import { GSS_PRODUCT_ID } from "@/utils/helpers/mappings"

function GssVarianceNotice() {
  const { contentBody: content } = useContentJsx(
    `dashboard_notifications.gss_variance`
  )

  const lastYear = new Date().getFullYear() - 1

  const yearParams = {
    startDate: lastYear + "-07-01",
    endDate: format(currentDate(), "yyyy-MM-dd"),
  }

  const hasGss = useSelector(selectHasGss)

  const { data, isFetching } =
    hasGss &&
    useVariancesQuery({
      id: GSS_PRODUCT_ID,
      ...yearParams,
    })

  if (!data || isFetching) {
    return null
  }

  return (
    <Notification notificationType={"alert"} closeButton={true}>
      {content}
    </Notification>
  )
}

export default GssVarianceNotice
